// CompanyFilterChips.jsx — 통합 메뉴 회사 필터 칩 (Phase 1-1e)
// 메뉴의 company_codes 각각에 대해 on/off 토글 칩. 최소 1개 강제 유지.
import React from 'react';
// 회사 색은 통합 메뉴 화면들과 한 곳에서 (2026-10-01)
import { companyColor } from '../integratedmenu/integratedFeatureMeta';
// 칩 글자 = 작업 대상과 같은 회사 이름(2026-10-15) — 고르는 값은 그대로 코드
import { useCompanyNames } from '../adminlayout/useCompanyNames';

export default function CompanyFilterChips({ companyCodes, selected, onChange }) {
  const nameOf = useCompanyNames();
  if (!Array.isArray(companyCodes) || companyCodes.length === 0) return null;

  const handleToggle = (code) => {
    if (selected.includes(code)) {
      // 마지막 1개 off 차단 — 최소 1개 강제
      if (selected.length === 1) return;
      onChange(selected.filter((c) => c !== code));
    } else {
      // on: 원래 company_codes 순서 유지해 정렬
      const next = [...selected, code];
      onChange(companyCodes.filter((c) => next.includes(c)));
    }
  };

  return (
    <div style={wrapStyle}>
      {companyCodes.map((code) => {
        const isOn = selected.includes(code);
        const color = companyColor(code);
        return (
          <button
            key={code}
            type="button"
            onClick={() => handleToggle(code)}
            style={isOn ? { ...chipBase, background: color.bg, color: color.fg, border: '1px solid transparent' } : chipOff}
            aria-pressed={isOn}
          >
            {isOn && <span style={checkStyle}>✓</span>}
            {nameOf(code)}
          </button>
        );
      })}
    </div>
  );
}

const wrapStyle = { display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' };
const chipBase = {
  padding: '4px 12px', borderRadius: 14, fontSize: 12, fontWeight: 600,
  cursor: 'pointer', transition: 'all 0.15s',
  display: 'inline-flex', alignItems: 'center', gap: 4,
};
const chipOff = {
  ...chipBase,
  background: 'transparent',
  color: 'var(--text-sub)',
  border: '1px solid var(--border)',
  opacity: 0.6,
};
const checkStyle = { fontSize: 11, fontWeight: 700 };
